import { toAccountLink } from '@peloton/external-links/models';

export const DOWNLOAD_APP_ROUTE = '/download/app';

export const SUBS_ROUTE = '/subscriptions';
export const MYMEMBERSHIP_ROUTE = '/mymembership';
export const UPDATE_CARD_ROUTE = '/account/update_card';
export const ONE_WELLNESS_ROUTE = '/benefits/corporate';
export const FREE_SUB_ID = 'app-free';

export const orderHistoryAccount = toAccountLink('/orderhistory');
export const myMembershipAccount = toAccountLink(MYMEMBERSHIP_ROUTE);

export const toBillingSubscriptionsUrl = () =>
  `${MYMEMBERSHIP_ROUTE}/billing${SUBS_ROUTE}`;
export const toV2BillingSubscriptionsUrl = () => `${MYMEMBERSHIP_ROUTE}/v2${SUBS_ROUTE}`;
export const toSubscriptionsUrl = () => `${MYMEMBERSHIP_ROUTE}${SUBS_ROUTE}`;

export const toBillingSubDetailsUrl = (id: string = ':id') =>
  `${toBillingSubscriptionsUrl()}/${id}`;
export const toV2BillingSubDetailsUrl = (id: string = ':id') =>
  `${toV2BillingSubscriptionsUrl()}/${id}`;

export const toV2BillingSubCancelSuccessUrl = (id: string = ':id') =>
  `${toV2BillingSubDetailsUrl(id)}/cancel-success`;

export const toSubDetailsUrl = (id: string = ':id') => `${toSubscriptionsUrl()}/${id}`;

export const toSwitchPlanUrl = (id: string = ':id') =>
  `${toSubDetailsUrl(id)}/switch-plan`;

export const to1wSwitchPlanUrl = (id: string = ':id') =>
  `${ONE_WELLNESS_ROUTE}/switch-plan/${id}`;

export const toUpgradePlanUrl = (id: string = ':id') =>
  `${toSubDetailsUrl(id)}/upgrade-plan`;

export const to1wUpgradePlanUrl = () => `${ONE_WELLNESS_ROUTE}/plan-checkout`;

export const toUpgradeFreeUrl = () => toSwitchPlanUrl(FREE_SUB_ID);

export const toSwitchBillingUrl = (id: string = ':id') =>
  `${toSubDetailsUrl(id)}/switch-billing`;

export const upgradePlanAccount = (id: string = ':id') =>
  toAccountLink(toUpgradePlanUrl(id));

export const switchPlanAccount = (id: string = ':id') =>
  toAccountLink(toSwitchPlanUrl(id));

export const switchBillingAccount = (id: string = ':id') =>
  toAccountLink(toSwitchBillingUrl(id));

export const upgrade1wFreeAccount = () => toAccountLink(to1wUpgradePlanUrl());
export const switch1wPlanAccount = (id: string = ':id') =>
  toAccountLink(to1wSwitchPlanUrl(id));

export const upgradeFreeAccount = () => toAccountLink(toUpgradeFreeUrl());
export const downloadAppSocialProspects = toAccountLink(DOWNLOAD_APP_ROUTE);
